import { InputHTMLAttributes } from "react"

const TextInput = ({className, ...props}: InputHTMLAttributes<HTMLElement>) => {
    return (
        <input
            type="text"
            className={`max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md ${className}`}
            {...props}
        />
    )
}

export default TextInput